import { useQuery } from 'react-query';
import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

export const usePhotoCardQuery = (
  reviewableId: string,
  reviewableType: 'TradingPhotoCard' | 'MatchedTradingPhotoCard',
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ['photoCard', reviewableId, reviewableType],
    enabled: options?.enabled !== false && !!reviewableId,
    queryFn: async () => {
      const response = await fetch(getTradingPhotoCardApiEndpoint(reviewableId, reviewableType), {
        headers: {
          method: 'GET',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        }
      });
      const data = await response.json();
      if (reviewableType === 'TradingPhotoCard') {
        return data.tradingPhotoCard;
      }
      if (reviewableType === 'MatchedTradingPhotoCard') {
        return data.matchedTradingPhotoCard;
      }
    }
  });
};

const getTradingPhotoCardApiEndpoint = (
  reviewableId: string,
  reviewableType: 'TradingPhotoCard' | 'MatchedTradingPhotoCard'
): string => {
  if (reviewableType === 'TradingPhotoCard') {
    return `${baseUrl()}/api/v1/trading_photo_cards/${reviewableId}`;
  }
  if (reviewableType === 'MatchedTradingPhotoCard') {
    return `${baseUrl()}/api/v1/matched_trading_photo_cards/${reviewableId}`;
  }
  throw new Error(`Unknown reviewableType: ${reviewableType}`);
};
